import { Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { RanaTable } from "@nens/ranalib";

import { useIconSrc } from "@/hooks/use-icon-src";

export function TableEmptyHistory({ isSearching }: { isSearching?: boolean }) {
  const icon = useIconSrc("clock");
  return (
    <RanaTable.Empty icon={icon}>
      <Text>
        {isSearching ? (
          <FormattedMessage
            id="projectfiles.no_history_found_search"
            defaultMessage="No history entries match your search"
          />
        ) : (
          <FormattedMessage
            id="projectfiles.no_history_found"
            defaultMessage="There is no activity yet"
          />
        )}
      </Text>
    </RanaTable.Empty>
  );
}
